import {Inject, Injectable} from '@angular/core';
import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError, map, take} from 'rxjs/operators';
import {LoadingService} from './loading.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import { OKTA_AUTH } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js'

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {

    constructor(
        private loadingService: LoadingService,
        private router: Router,
        public toasterService: ToastrService,
        @Inject(OKTA_AUTH) private _oktaAuth: OktaAuth
    ) {
    }

    getErrorMessage(error) {
        let errorMessage = 'unknown error';
        if (error.error instanceof ErrorEvent) {
            // client-side error
            errorMessage = `Error: ${error.error.message}`;
        } else {
            // server-side error
            if (error.status !== 0) {
                errorMessage = ` Message: ${!!error?.error?.message ? error.error?.message : error.message}`;
            }
        }
        console.log(errorMessage);
        return errorMessage;
    }


    handleError(error, request) {
        const errorMessage = this.getErrorMessage(error);
        if (!error.url.includes('/apiOrganisation/target/employee/email/')) {
            this.loadingService.clearLoading();
            this.toasterService.error('', 'Une erreur est survenue; veuillez reprendre la saisie via eContrat', {
                positionClass: 'toast-center-center',
                timeOut: 10000
            });
            if (this.router.url !== '/') {
                this.router.navigate(['/opportunities']);
            }

        } else {
            this.loadingService.setLoading(false, request.url);
        }
        return errorMessage;
    }


    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.loadingService.setLoading(true, request.url);

        return next.handle(this.addAuthHeaderToAllowedOrigins(request))
            .pipe(catchError((err) => {
                    return this.handleError(err, request);
                }),
                map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
                    if (evt instanceof HttpResponse) {
                        this.loadingService.setLoading(false, request.url);
                    }
                    return evt;
                }));
    }
    private addAuthHeaderToAllowedOrigins(request: HttpRequest<unknown>): HttpRequest<unknown> {

        const authToken = this._oktaAuth.getAccessToken();
        const req = request.clone({ setHeaders: { 'Authorization': `Bearer ${authToken}` } });
        return req;
    }
}

